import React, { useContext } from 'react';
import { Col, Row } from 'antd';

import DeviceContext from '@totem/components/devices/deviceDetails/DeviceContext';
import { sortStringAscending } from '@totem/components/services/threats/eventsContainer_legacy/utilities';
import HeaderItem from '@totem/components/ui_components/headers/HeaderItem';

const NetworkDetails = () => {
  const { deviceData } = useContext(DeviceContext);

  return (
    <Row>
      <Col span={8}>
        <HeaderItem title="MAC Addresses">
          {deviceData.device.keys
            .filter((key) => key.type === 'MAC_ADDRESS')
            .sort((compA, compB) =>
              sortStringAscending(compA.value, compB.value),
            )
            .map((key) => (
              <span key={key.value}>
                {key.value}
                <br />
              </span>
            ))}
        </HeaderItem>
      </Col>
      <Col span={8}>
        <HeaderItem title="IP Addresses">
          {deviceData.device.ipAddresses
            .sort((compA, compB) => sortStringAscending(compA, compB))
            .map((ip) => (
              <span key={ip}>
                {ip}
                <br />
              </span>
            ))}
        </HeaderItem>
      </Col>
      <Col span={8}>&nbsp;</Col>
    </Row>
  );
};

export default NetworkDetails;
